import wixData from 'wix-data';

 

$w.onReady(function () {

    uniqueDropDown1();

});


function uniqueDropDown1 (){

    wixData.query("Team")

        .limit(1000)

      .find()

      .then(results => {

           const uniqueTitles = getUniqueTitles(results.items);

           $w("#dropdownstate").options = buildOptions(uniqueTitles);

      });

  function getUniqueTitles(items) {

        const titlesOnly = items.map(item => item.region);

     return [...new Set(titlesOnly)];

    }

    function buildOptions(uniqueList) {

        return uniqueList.map(curr => {

            return {label:curr, value:curr};

        });

    }

}

 

export function genre_change(event, $w) {

uniqueDropDown2();

$w("#dropdowncity").enable();

}

 

function uniqueDropDown2 (){

    wixData.query("Team")

        .contains("city", $w("#dropdowncity").value)

        .limit(1000)

      .find()

      .then(results => {

           const uniqueTitles = getUniqueTitles(results.items);

           $w("#dropdowncity").options = buildOptions(uniqueTitles);

      });

  function getUniqueTitles(items) {

        const titlesOnly = items.map(item => item.city);

     return [...new Set(titlesOnly)];

    }

    function buildOptions(uniqueList) {

        return uniqueList.map(curr => {

            return {label:curr, value:curr};

        });

    }

}
 
export function ititle_keyPress_1(event) {

let searchvalue = $w("#ititle").value;
$w("#dataset1").setFilter(wixData.filter().contains("title", searchvalue));


}

